module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/terms-and-conditions/terms-and-conditions.component.scss
// module id = ./src/app/terms-and-conditions/terms-and-conditions.component.scss
// module chunks = main